'use strict';

var lang = require('../lang'),
    isUpper = false;

module.exports = {
    get: function ( direction, callback ) {
        var data = require('./language.layouts/' + lang.codes[lang.active]);

        if ( isUpper ) {
            data = data.map(function ( row ) {
                return row.map(function ( item ) {
                    if ( typeof item.action === 'undefined' ) {
                        if ( typeof item.value !== 'undefined' ) {
                            item.value = item.value.toUpperCase();
                        } else if ( typeof item === 'string' ) {
                            item = item.toUpperCase();
                        }
                    }

                    return item;
                });
            });
        } else {
            data = data.map(function ( row ) {
                return row.map(function ( item ) {
                    if ( typeof item.action === 'undefined' ) {
                        if ( typeof item.value !== 'undefined' ) {
                            item.value = item.value.toLowerCase();
                        } else if ( typeof item === 'string' ) {
                            item = item.toLowerCase();
                        }
                    }

                    return item;
                });
            });
        }
        lang.currentProvider = this;
        callback(false, data);
    },
    toggleCase: function (  ) {
        isUpper = !isUpper;
    }
};
